naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'
React = require 'react'
t = require('views/internal/recup-with-helpers')('select_member')
l = require 'lib/localize'

module.exports = class AutocompleteMemberAvatar extends React.Component
  displayName: 'AutocompleteMemberAvatar'

  constructor: (props) ->
    super(props)

  shouldComponentUpdate: naiveShouldComponentUpdate

  render: t.renderable ->
    {
      active,
      avatarHash,
      email,
      username,
      team,
      confirmed,
      joined,
      fullName,
      memberType,
      initials,
      isDeactivated,
      isBoardAdmin,
      isOrganizationAdmin,
      idOrganizations,
      onMouseDown,
      onRemoveClick,
      displayDetails,
      displayOrg,
      displayUsername
    } = @props

    # using mousedown instead of click on the option allows us to
    # select the option and then have the input blur happen afterwards
    t.div ".member-container", { onMouseDown }, ->
      if displayUsername
        title = "#{ fullName } (#{ username })"
      else
        title = fullName
      if active and username
        t.div '.member', ->
          if avatarHash
            avatarUrl = [window.avatarDomain, avatarHash, '30.png'].join('/')
            avatarUrl2x = [window.avatarDomain, avatarHash, '50.png'].join('/')
            t.img {
              class: 'member-avatar'
              height: '30'
              width: '30'
              src: avatarUrl
              srcSet: "#{avatarUrl} 1x, #{avatarUrl2x} 2x"
              alt: title
              title
            }

          else if initials?

            t.span t.classify(
              '.member-initials': true,
              'long-initials': initials.length > 2
            ), { title }, ->
              t.text initials
        t.div '.member-info', ->
          t.div '.full-name', ->
            t.text title

          if displayDetails
            if joined
              if memberType? == 'ghost'
                t.span '.quiet.sub-name', ->
                  t.text l('invited')
              else
                t.span '.quiet.sub-name', ->
                  t.text "(#{l('joined')})"
            else
              if !confirmed
                t.span '.quiet.sub-name', ->
                  t.format 'unconfirmed-user'

              if !active
                t.span '.quiet.sub-name', ->
                  t.format 'inactive-account'
          if displayOrg? && idOrganizations
            if displayOrg.id in idOrganizations
              t.span '.quiet.sub-name', ->
                t.text displayOrg.get('displayName')

        if !isDeactivated
          if isBoardAdmin
            t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-board') }
          if isOrganizationAdmin
            t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-organization') }

        t.span '.member-gold-badge', { title: t.l('this-member-has-trello-gold') }
      # the email provided does not have an associated trello user
      else
        t.div ->
          t.div '.member-info', ->
            t.div '.full-name', ->
              t.text email

      if onRemoveClick
        t.a '.icon-sm .icon-close', { onClick: onRemoveClick, href: '#' }



// WEBPACK FOOTER //
// ./app/scripts/views/organization/invite-member-autocomplete-avatar.coffee